import { ServerResponse } from "framework/http/ApiClient"
import { GetEventsAPI, ScheduledEvent } from "types"

export const GET_EVENTS : ServerResponse<GetEventsAPI.retval> = {
  requestId : '123',
  payload : [
      {
        eventId : "6a321404-a5f7-11ed-afa1-0242ac120002",
        eventName : "Critical Peak Price_30Dec2022",
        eventType : ScheduledEvent.EventType.CPP,
        eventStatus : ScheduledEvent.EventStatus.ONGOING,
        creationTimeEpoch : 1675671181,
        startTimeEpoch : 1675671181,
        endTimeEpoch  : 1675671181,
        communications : [
          {
            communcationType : ScheduledEvent.CommunicationType.EMAIL,
            alertList : [
              {
                alertType : ScheduledEvent.CommunicationAlertType.CPE_PRE_EVENT,
                status : ScheduledEvent.CommunicationAlertStatus.SENT,
                dateEpoch : 1675671181
              },
              {
                alertType : ScheduledEvent.CommunicationAlertType.CPE_EVENT_START,
                status : ScheduledEvent.CommunicationAlertStatus.SENT,
                dateEpoch : 1675671181
              },
              {
                alertType : ScheduledEvent.CommunicationAlertType.CPE_EVENT_END,
                status : ScheduledEvent.CommunicationAlertStatus.SENT,
                dateEpoch : 1675671181
              }
            ]
          }
        ]
      },
      {
        eventId : "6a321404-a5f7-11ed-afa1-0242ac120002",
        eventName : "Critical Peak Price_30Dec2022",
        eventType : ScheduledEvent.EventType.CPP,
        eventStatus : ScheduledEvent.EventStatus.ONGOING,
        creationTimeEpoch : 1675671181,
        startTimeEpoch : 1675671181,
        endTimeEpoch  : 1675671181,
        communications : [
          {
            communcationType : ScheduledEvent.CommunicationType.EMAIL,
            alertList : [
              {
                alertType : ScheduledEvent.CommunicationAlertType.CPE_PRE_EVENT,
                status : ScheduledEvent.CommunicationAlertStatus.SENT,
                dateEpoch : 1675671181
              },
              {
                alertType : ScheduledEvent.CommunicationAlertType.CPE_EVENT_START,
                status : ScheduledEvent.CommunicationAlertStatus.SENT,
                dateEpoch : 1675671181
              },
              {
                alertType : ScheduledEvent.CommunicationAlertType.CPE_EVENT_END,
                status : ScheduledEvent.CommunicationAlertStatus.SENT,
                dateEpoch : 1675671181
              }
            ]
          }
        ]
      },
      {
        eventId : "6a321404-a5f7-11ed-afa1-0242ac120002",
        eventName : "Critical Peak Price_30Dec2022",
        eventType : ScheduledEvent.EventType.CPP,
        eventStatus : ScheduledEvent.EventStatus.ONGOING,
        creationTimeEpoch : 1675671181,
        startTimeEpoch : 1676894400,
        endTimeEpoch  : 1676894400,
        communications : [
          {
            communcationType : ScheduledEvent.CommunicationType.EMAIL,
            alertList : [
              {
                alertType : ScheduledEvent.CommunicationAlertType.CPE_PRE_EVENT,
                status : ScheduledEvent.CommunicationAlertStatus.SENT,
                dateEpoch : 1675671181
              },
              {
                alertType : ScheduledEvent.CommunicationAlertType.CPE_EVENT_START,
                status : ScheduledEvent.CommunicationAlertStatus.SENT,
                dateEpoch : 1675671181
              },
              {
                alertType : ScheduledEvent.CommunicationAlertType.CPE_EVENT_END,
                status : ScheduledEvent.CommunicationAlertStatus.SENT,
                dateEpoch : 1675671181
              }
            ]
          }
        ]
      },
      {
        eventId : "6a321404-a5f7-11ed-afa1-0242ac120002",
        eventName : "Critical Peak Price_30Dec2022",
        eventType : ScheduledEvent.EventType.CPP,
        eventStatus : ScheduledEvent.EventStatus.ONGOING,
        creationTimeEpoch : 1675671181,
        startTimeEpoch : 1676894400,
        endTimeEpoch  : 1676894400,
        communications : [
          {
            communcationType : ScheduledEvent.CommunicationType.EMAIL,
            alertList : [
              {
                alertType : ScheduledEvent.CommunicationAlertType.CPE_PRE_EVENT,
                status : ScheduledEvent.CommunicationAlertStatus.SENT,
                dateEpoch : 1675671181
              },
              {
                alertType : ScheduledEvent.CommunicationAlertType.CPE_EVENT_START,
                status : ScheduledEvent.CommunicationAlertStatus.SENT,
                dateEpoch : 1675671181
              },
              {
                alertType : ScheduledEvent.CommunicationAlertType.CPE_EVENT_END,
                status : ScheduledEvent.CommunicationAlertStatus.SENT,
                dateEpoch : 1675671181
              }
            ]
          }
        ]
      },
      {
        eventId : "6a321404-a5f7-11ed-afa1-0242ac120002",
        eventName : "Critical Peak Price_30Dec2022",
        eventType : ScheduledEvent.EventType.CPP,
        eventStatus : ScheduledEvent.EventStatus.ONGOING,
        creationTimeEpoch : 1675671181,
        startTimeEpoch : 1676894400,
        endTimeEpoch  : 1676894400,
        communications : [
          {
            communcationType : ScheduledEvent.CommunicationType.EMAIL,
            alertList : [
              {
                alertType : ScheduledEvent.CommunicationAlertType.CPE_PRE_EVENT,
                status : ScheduledEvent.CommunicationAlertStatus.SENT,
                dateEpoch : 1675671181
              },
              {
                alertType : ScheduledEvent.CommunicationAlertType.CPE_EVENT_START,
                status : ScheduledEvent.CommunicationAlertStatus.SENT,
                dateEpoch : 1675671181
              },
              {
                alertType : ScheduledEvent.CommunicationAlertType.CPE_EVENT_END,
                status : ScheduledEvent.CommunicationAlertStatus.SENT,
                dateEpoch : 1675671181
              }
            ]
          }
        ]
      },
      {
        eventId : "6a321404-a5f7-11ed-afa1-0242ac120002",
        eventName : "Critical Peak Price_30Dec2022",
        eventType : ScheduledEvent.EventType.CPP,
        eventStatus : ScheduledEvent.EventStatus.ONGOING,
        creationTimeEpoch : 1675671181,
        startTimeEpoch : 1676894400,
        endTimeEpoch  : 1676894400,
        communications : [
          {
            communcationType : ScheduledEvent.CommunicationType.EMAIL,
            alertList : [
              {
                alertType : ScheduledEvent.CommunicationAlertType.CPE_PRE_EVENT,
                status : ScheduledEvent.CommunicationAlertStatus.SENT,
                dateEpoch : 1675671181
              },
              {
                alertType : ScheduledEvent.CommunicationAlertType.CPE_EVENT_START,
                status : ScheduledEvent.CommunicationAlertStatus.SENT,
                dateEpoch : 1675671181
              },
              {
                alertType : ScheduledEvent.CommunicationAlertType.CPE_EVENT_END,
                status : ScheduledEvent.CommunicationAlertStatus.SENT,
                dateEpoch : 1675671181
              }
            ]
          }
        ]
      },
      {
        eventId : "6a321404-a5f7-11ed-afa1-0242ac120002",
        eventName : "Critical Peak Price_30Dec2022",
        eventType : ScheduledEvent.EventType.CPP,
        eventStatus : ScheduledEvent.EventStatus.ONGOING,
        creationTimeEpoch : 1675671181,
        startTimeEpoch : 1676894400,
        endTimeEpoch  : 1676894400,
        communications : [
          {
            communcationType : ScheduledEvent.CommunicationType.EMAIL,
            alertList : [
              {
                alertType : ScheduledEvent.CommunicationAlertType.CPE_PRE_EVENT,
                status : ScheduledEvent.CommunicationAlertStatus.SENT,
                dateEpoch : 1675671181
              },
              {
                alertType : ScheduledEvent.CommunicationAlertType.CPE_EVENT_START,
                status : ScheduledEvent.CommunicationAlertStatus.SENT,
                dateEpoch : 1675671181
              },
              {
                alertType : ScheduledEvent.CommunicationAlertType.CPE_EVENT_END,
                status : ScheduledEvent.CommunicationAlertStatus.SENT,
                dateEpoch : 1675671181
              }
            ]
          }
        ]
      },
      {
        eventId : "6a321404-a5f7-11ed-afa1-0242ac120002",
        eventName : "Critical Peak Price_30Dec2022",
        eventType : ScheduledEvent.EventType.CPP,
        eventStatus : ScheduledEvent.EventStatus.ONGOING,
        creationTimeEpoch : 1675671181,
        startTimeEpoch : 1676894400,
        endTimeEpoch  : 1676894400,
        communications : [
          {
            communcationType : ScheduledEvent.CommunicationType.EMAIL,
            alertList : [
              {
                alertType : ScheduledEvent.CommunicationAlertType.CPE_PRE_EVENT,
                status : ScheduledEvent.CommunicationAlertStatus.SENT,
                dateEpoch : 1675671181
              },
              {
                alertType : ScheduledEvent.CommunicationAlertType.CPE_EVENT_START,
                status : ScheduledEvent.CommunicationAlertStatus.SENT,
                dateEpoch : 1675671181
              },
              {
                alertType : ScheduledEvent.CommunicationAlertType.CPE_EVENT_END,
                status : ScheduledEvent.CommunicationAlertStatus.SENT,
                dateEpoch : 1675671181
              }
            ]
          }
        ]
      },
      {
        eventId : "6a321404-a5f7-11ed-afa1-0242ac120002",
        eventName : "Critical Peak Price_30Dec2022",
        eventType : ScheduledEvent.EventType.CPP,
        eventStatus : ScheduledEvent.EventStatus.ONGOING,
        creationTimeEpoch : 1675671181,
        startTimeEpoch : 1676894400,
        endTimeEpoch  : 1676894400,
        communications : [
          {
            communcationType : ScheduledEvent.CommunicationType.EMAIL,
            alertList : [
              {
                alertType : ScheduledEvent.CommunicationAlertType.CPE_PRE_EVENT,
                status : ScheduledEvent.CommunicationAlertStatus.SENT,
                dateEpoch : 1675671181
              },
              {
                alertType : ScheduledEvent.CommunicationAlertType.CPE_EVENT_START,
                status : ScheduledEvent.CommunicationAlertStatus.SENT,
                dateEpoch : 1675671181
              },
              {
                alertType : ScheduledEvent.CommunicationAlertType.CPE_EVENT_END,
                status : ScheduledEvent.CommunicationAlertStatus.SENT,
                dateEpoch : 1675671181
              }
            ]
          }
        ]
      },
      {
        eventId : "6a321404-a5f7-11ed-afa1-0242ac120002",
        eventName : "Critical Peak Price_30Dec2022",
        eventType : ScheduledEvent.EventType.CPP,
        eventStatus : ScheduledEvent.EventStatus.ONGOING,
        creationTimeEpoch : 1675671181,
        startTimeEpoch : 1676894400,
        endTimeEpoch  : 1676894400,
        communications : [
          {
            communcationType : ScheduledEvent.CommunicationType.EMAIL,
            alertList : [
              {
                alertType : ScheduledEvent.CommunicationAlertType.CPE_PRE_EVENT,
                status : ScheduledEvent.CommunicationAlertStatus.SENT,
                dateEpoch : 1675671181
              },
              {
                alertType : ScheduledEvent.CommunicationAlertType.CPE_EVENT_START,
                status : ScheduledEvent.CommunicationAlertStatus.SENT,
                dateEpoch : 1675671181
              },
              {
                alertType : ScheduledEvent.CommunicationAlertType.CPE_EVENT_END,
                status : ScheduledEvent.CommunicationAlertStatus.SENT,
                dateEpoch : 1675671181
              }
            ]
          }
        ]
      },
      {
        eventId : "6a321404-a5f7-11ed-afa1-0242ac120002",
        eventName : "Critical Peak Price_30Dec2022",
        eventType : ScheduledEvent.EventType.CPP,
        eventStatus : ScheduledEvent.EventStatus.ONGOING,
        creationTimeEpoch : 1675671181,
        startTimeEpoch : 1676894400,
        endTimeEpoch  : 1676894400,
        communications : [
          {
            communcationType : ScheduledEvent.CommunicationType.EMAIL,
            alertList : [
              {
                alertType : ScheduledEvent.CommunicationAlertType.CPE_PRE_EVENT,
                status : ScheduledEvent.CommunicationAlertStatus.SENT,
                dateEpoch : 1675671181
              },
              {
                alertType : ScheduledEvent.CommunicationAlertType.CPE_EVENT_START,
                status : ScheduledEvent.CommunicationAlertStatus.SENT,
                dateEpoch : 1675671181
              },
              {
                alertType : ScheduledEvent.CommunicationAlertType.CPE_EVENT_END,
                status : ScheduledEvent.CommunicationAlertStatus.SENT,
                dateEpoch : 1675671181
              }
            ]
          }
        ]
      },
      {
        eventId : "6a321404-a5f7-11ed-afa1-0242ac120002",
        eventName : "Critical Peak Price_30Dec2022",
        eventType : ScheduledEvent.EventType.CPP,
        eventStatus : ScheduledEvent.EventStatus.ONGOING,
        creationTimeEpoch : 1675671181,
        startTimeEpoch : 1676894400,
        endTimeEpoch  : 1676894400,
        communications : [
          {
            communcationType : ScheduledEvent.CommunicationType.EMAIL,
            alertList : [
              {
                alertType : ScheduledEvent.CommunicationAlertType.CPE_PRE_EVENT,
                status : ScheduledEvent.CommunicationAlertStatus.SENT,
                dateEpoch : 1675671181
              },
              {
                alertType : ScheduledEvent.CommunicationAlertType.CPE_EVENT_START,
                status : ScheduledEvent.CommunicationAlertStatus.SENT,
                dateEpoch : 1675671181
              },
              {
                alertType : ScheduledEvent.CommunicationAlertType.CPE_EVENT_END,
                status : ScheduledEvent.CommunicationAlertStatus.SENT,
                dateEpoch : 1675671181
              }
            ]
          }
        ]
      },
      {
        eventId : "6a321404-a5f7-11ed-afa1-0242ac120002",
        eventName : "Critical Peak Price_30Dec2022",
        eventType : ScheduledEvent.EventType.CPP,
        eventStatus : ScheduledEvent.EventStatus.ONGOING,
        creationTimeEpoch : 1675671181,
        startTimeEpoch : 1676894400,
        endTimeEpoch  : 1676894400,
        communications : [
          {
            communcationType : ScheduledEvent.CommunicationType.EMAIL,
            alertList : [
              {
                alertType : ScheduledEvent.CommunicationAlertType.CPE_PRE_EVENT,
                status : ScheduledEvent.CommunicationAlertStatus.SENT,
                dateEpoch : 1675671181
              },
              {
                alertType : ScheduledEvent.CommunicationAlertType.CPE_EVENT_START,
                status : ScheduledEvent.CommunicationAlertStatus.SENT,
                dateEpoch : 1675671181
              },
              {
                alertType : ScheduledEvent.CommunicationAlertType.CPE_EVENT_END,
                status : ScheduledEvent.CommunicationAlertStatus.SENT,
                dateEpoch : 1675671181
              }
            ]
          }
        ]
      },
      {
        eventId : "6a321404-a5f7-11ed-afa1-0242ac120002",
        eventName : "Critical Peak Price_30Dec2022",
        eventType : ScheduledEvent.EventType.CPP,
        eventStatus : ScheduledEvent.EventStatus.ONGOING,
        creationTimeEpoch : 1675671181,
        startTimeEpoch : 1676894400,
        endTimeEpoch  : 1676894400,
        communications : [
          {
            communcationType : ScheduledEvent.CommunicationType.EMAIL,
            alertList : [
              {
                alertType : ScheduledEvent.CommunicationAlertType.CPE_PRE_EVENT,
                status : ScheduledEvent.CommunicationAlertStatus.SENT,
                dateEpoch : 1675671181
              },
              {
                alertType : ScheduledEvent.CommunicationAlertType.CPE_EVENT_START,
                status : ScheduledEvent.CommunicationAlertStatus.SENT,
                dateEpoch : 1675671181
              },
              {
                alertType : ScheduledEvent.CommunicationAlertType.CPE_EVENT_END,
                status : ScheduledEvent.CommunicationAlertStatus.SENT,
                dateEpoch : 1675671181
              }
            ]
          }
        ]
      }
    ],
  error : null
} 